export default [
  {
    path: '/administrators',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "administrators-list" */ "@/views/administrators/List.vue"),
  }, {
    path: '/administrators/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "administrators-create" */ "@/views/administrators/Create.vue"),
  }, {
    path: '/administrators/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: "administrators" */ "@/views/administrators/Administrator.vue"),
  }
]
